module.exports = __webpack_public_path__ + "static/media/StmTechLogo.5fd5ef84.png";